import React from 'react';
import { Grid } from '@material-ui/core';
import { FacesheetCardList, HistoryTypography, } from 'shared-assets/facesheet-ui/utils/styledFacesheet';
import HistorySectionHeader from 'shared-assets/facesheet-ui/components/Facesheet/History/HistorySectionHeader';
var HistorySection = function (_a) {
    var title = _a.title, historyData = _a.historyData, _b = _a.historyComments, historyComments = _b === void 0 ? null : _b, formatDisplayText = _a.formatDisplayText, _c = _a.familyHistoryUnknown, familyHistoryUnknown = _c === void 0 ? false : _c;
    return (React.createElement(Grid, { item: true },
        React.createElement(HistorySectionHeader, { title: title }),
        React.createElement(FacesheetCardList, null,
            React.createElement(HistoryTypography, { variant: "body1", component: "div" },
                familyHistoryUnknown && 'Family history unknown',
                historyData.map(function (item, index) { return (React.createElement("li", { key: index }, formatDisplayText(item))); }),
                historyComments && React.createElement("li", null,
                    "Comments: ",
                    historyComments)))));
};
export default HistorySection;
